import { BeneficiaryOrderEnum } from '../../enums/BeneficiaryOrderEnum';
import { BeneficiaryTypeEnum } from '../../enums/BeneficiaryTypeEnum';
import { CustomerDto } from './CustomerDto';

export class BeneficiaryDto {
  id: number;

  beneficiaryOrderEnum: BeneficiaryOrderEnum;

  relationToInsured: BeneficiaryTypeEnum;

  orderNumber: number;

  customer: CustomerDto;
}
